import { Injectable } from '@angular/core';
import { StorageType } from '@core/enums/storage.enum';

@Injectable({
	providedIn: 'root',
})
export class StorageService {
	setItem(key: string, value: string): void {
		localStorage.setItem(key, value);
	}

	getItem(key: string): any {
		return localStorage.getItem(key) || '';
	}

	removeItem(key: string): void {
		localStorage.removeItem(key);
	}

	clear(): void {
		const LOCALE = this.getItem(StorageType.LOCALE);
		const TRANSLATIONS = this.getItem(StorageType.TRANSLATIONS);

		localStorage.clear();

		// Locale related data should be preserved when clearing local storage
		this.setItem(StorageType.LOCALE, LOCALE);
		this.setItem(StorageType.TRANSLATIONS, JSON.stringify(TRANSLATIONS));
	}
}
